import React, { createContext, useState, useContext, ReactNode, useEffect, Dispatch, SetStateAction } from 'react';

interface CartContextType {
  cartQuantity: number | null;
  setCartQuantity: Dispatch<SetStateAction<number | null>>;
  fetchCartQuantity: (sessionCode: string) => Promise<void>;
  handleQuantity: () => void;
  getBannerOrImageAltTag: (title: any, categoryDetails: any) => string;
  voucherUpdateInServer: (payload: any, csrfToken: any, auth_token: any) => any;
  createOrderLevelVoucherPayload: (voucher: any, sess_code: any) => any;
  createOrderItemLevelVoucherPayload: (voucher: any, sess_code: any) => any;
  createItemVoucherRemovePayload: (voucher: any, sess_code: any) => any;
  createOrderVoucherRemovePayload: (sess_code: any) => any;
}

const CartContext = createContext<CartContextType | undefined>(undefined);
const backendUrl = process.env.REACT_APP_BACKEND_URL;

export const CartProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [cartQuantity, setCartQuantity] = useState<number | null>(() => {
        const savedQuantity = localStorage.getItem('cartQuantity');
        return savedQuantity ? Math.max(parseInt(savedQuantity, 10), 0) : null;
    });

    const [showModal, setShowModal] = useState(false); // State to track modal visibility

    // Function to fetch cart quantity from the API
    const fetchCartQuantity = async (sessionCode: string) => {
        try {
            if(sessionCode){
                  

                const response = await fetch(`${backendUrl}api/v2/cartQty/${sessionCode}`,
                    {  method: 'GET',
                        headers:{
                          // Accept:'aplication/json',
                          "Content-Type": "application/json",
                  
                        },
                        
                        credentials: "include",
                        mode:"cors"
        
                      }
                );
                // //  
                const data = await response.json();
    
                  
    
                if (response.ok && data) {
                    const fetchedQuantity = Math.max(data.data.totalQty, 0); // Ensure it's non-negative
                    setCartQuantity(fetchedQuantity); // Update state
                    localStorage.setItem('cartQuantity', String(fetchedQuantity));
    
                } else {
                    //console.error('Failed to fetch cart quantity');
                }
            }
            
        } catch (error) {
            //console.error('Error fetching cart quantity:', error);
        }
    };

    // Ensure localStorage updates when cartQuantity changes
    useEffect(() => {
        //   
        if (cartQuantity !== null) {
            const nonNegativeQuantity = Math.max(cartQuantity, 0);
            localStorage.setItem('cartQuantity', String(nonNegativeQuantity));
        } else {
            localStorage.removeItem('cartQuantity');
        }
    }, [cartQuantity]);

    // Function to close the modal
    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleQuantity = () => {
        localStorage.removeItem("cartQuantity");
        sessionStorage.removeItem("cartQuantity");
    }

    const getBannerOrImageAltTag = (title: any,categoryDetails:any) => {
      if (title === "banner") {
        return categoryDetails?.banner_alt_tag
          ? categoryDetails.banner_alt_tag
          : categoryDetails?.title;
      } else if (title === "image") {
        return categoryDetails?.image_alt_tag
          ? categoryDetails.image_alt_tag
          : categoryDetails?.title;
      }
    };

    const voucherUpdateInServer = async (payload: any,csrfToken:any,auth_token:any) => {
      try {
        const response = await fetch(
          `${backendUrl}api/v2/voucher/update-or-remove-voucher`,
          {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json",
              "auth-token": `${auth_token}`,
              "X-CSRF-Token": csrfToken,
            },
            credentials: "include",
            body: JSON.stringify(payload),
          }
        );
        const data = await response.json();
        // window.location.reload()
        return data
      } catch (error) {
        //console.error("Error updating cart item brand:", error);
      }
    };
    const createOrderLevelVoucherPayload = (selectedVoucher: any,sess_code:any) => {
    return {
      order_level:true, item_level:false, order_voucher_id:selectedVoucher?.voucher_id, item_voucher_data:[], sess_id:sess_code, add_or_update_voucher:true, remove_voucher:false
    }
    
  }
  const createOrderItemLevelVoucherPayload = (appliedVoucher: any,sess_code:any) => {
    return {
      order_level:false, item_level:true, order_voucher_id:null, item_voucher_data:appliedVoucher, sess_id:sess_code, add_or_update_voucher:true, remove_voucher:false
    }
    
    }
    const createItemVoucherRemovePayload = (item_data: any,sess_code:any) => {
     return {
      order_level:false, item_level:true, order_voucher_id:null, item_voucher_data:item_data, sess_id:sess_code, add_or_update_voucher:false, remove_voucher:true
    }
  }
  const createOrderVoucherRemovePayload = (sess_code:any) => {
    return {
      order_level:true, item_level:false, order_voucher_id:null, item_voucher_data:[], sess_id:sess_code, add_or_update_voucher:false, remove_voucher:true
    }
  }


    return (
        <CartContext.Provider value={{ cartQuantity, setCartQuantity, fetchCartQuantity ,handleQuantity,getBannerOrImageAltTag,voucherUpdateInServer,createOrderLevelVoucherPayload,createOrderItemLevelVoucherPayload,createItemVoucherRemovePayload,createOrderVoucherRemovePayload}}>
            {children}

            {/* Modal */}
            {showModal && (
                <div style={modalStyles.overlay}>
                    <div style={modalStyles.modal}>
                        <p>Your cart is empty. Please add items first.</p>
                        <button style={modalStyles.button} onClick={handleCloseModal}>Sell Now</button>
                    </div>
                </div>
            )}
        </CartContext.Provider>
    );
};

// Basic inline styles for the modal
// Basic inline styles for the modal
const modalStyles: { overlay: React.CSSProperties; modal: React.CSSProperties; button: React.CSSProperties  } = {
    overlay: {
        position: 'fixed', // Valid string for 'position'
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    modal: {
        backgroundColor: 'white',
        padding: '40px',
        borderRadius: '8px',
        textAlign: 'center',
    },
    button: {
        padding: '5px',
        margin: '8px',
    }
};

export const useCart = (): CartContextType => {
    const context = useContext(CartContext);
    if (context === undefined) {
        throw new Error('useCart must be used within a CartProvider');
    }
    return context;
};
